import carrot1 from "../../assets/games/picnic-game/picnic-story/carrot/carrot1.png";
import carrot2 from "../../assets/games/picnic-game/picnic-story/carrot/carrot2.png";
import carrot3 from "../../assets/games/picnic-game/picnic-story/carrot/carrot3.png";
import carrot4 from "../../assets/games/picnic-game/picnic-story/carrot/carrot4.png";
import carrot5 from "../../assets/games/picnic-game/picnic-story/carrot/carrot5.png";
import carrot6 from "../../assets/games/picnic-game/picnic-story/carrot/carrot6.png";
import carrot7 from "../../assets/games/picnic-game/picnic-story/carrot/carrot7.png";
import carrot8 from "../../assets/games/picnic-game/picnic-story/carrot/carrot8.png";

import broccoli1 from "../../assets/games/picnic-game/picnic-story/broccoli/broccoli1.png";
import broccoli2 from "../../assets/games/picnic-game/picnic-story/broccoli/broccoli2.png";
import broccoli3 from "../../assets/games/picnic-game/picnic-story/broccoli/broccoli3.png";
import broccoli4 from "../../assets/games/picnic-game/picnic-story/broccoli/broccoli4.png";
import broccoli5 from "../../assets/games/picnic-game/picnic-story/broccoli/broccoli5.png";
import broccoli6 from "../../assets/games/picnic-game/picnic-story/broccoli/broccoli6.png";

const storyImagesObj = {
  carrot1,
  carrot2,
  carrot3,
  carrot4,
  carrot5,
  carrot6,
  carrot7,
  carrot8,
  broccoli1,
  broccoli2,
  broccoli3,
  broccoli4,
  broccoli5,
  broccoli6,
};

export default storyImagesObj;
